<template>
  <el-card class="card" :bodyStyle="{ height: '100%' }">
    <div class="cardBody">
      <div class="log-page-content">
        <div style="display: flex; flex-wrap: wrap">
          <div class="condition-item" v-if="search">
            <label class="fn-14">查询时间</label>
            <el-date-picker
              v-model="searchTimeRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              :clearable="false"
              class="time-range"
              size="small"
            />
            <el-button-group class="quick-time-range">
              <el-button size="small" @click="setTimeRange('today')"
                >今天</el-button
              >
              <el-button size="small" @click="setTimeRange('yesterday')"
                >昨日</el-button
              >
              <el-button size="small" @click="setTimeRange('sevenDays')"
                >近 7 天</el-button
              >
            </el-button-group>
          </div>
          <div class="condition-item" v-if="search">
            <label class="fn-14">关键字</label>
            <el-input
              v-model="searchKeyword"
              placeholder="接口、操作说明或业务提示"
              style="width: 202px; margin-right: 20px"
              clearable
              autocomplete="off"
              size="small"
              @keyup.enter.native="handleSearch"
            />
          </div>
          <div class="condition-item" v-if="search">
            <label class="fn-14">实际操作人</label>
            <el-input
              v-model="searchOperatorKeyword"
              placeholder="后台人员、学生姓名或学生 ID"
              style="width: 202px; margin-right: 20px"
              clearable
              autocomplete="off"
              size="small"
              @keyup.enter.native="handleSearch"
            />
          </div>
          <div class="condition-item" v-if="search">
            <label class="fn-14">业务结果</label>
            <el-select
              v-model="searchBusinessResult"
              placeholder="全部结果"
              style="width: 150px; margin-right: 20px"
              clearable
              size="small"
            >
              <el-option
                v-for="item in businessResultOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
          <div class="condition-item" v-if="search">
            <label class="fn-14">日志类型</label>
            <el-select
              v-model="searchLogType"
              placeholder="请选择日志类型"
              style="width: 202px; margin-right: 20px"
              clearable
              autocomplete="off"
              size="small"
            >
              <el-option
                v-for="item in logTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="condition-item" v-if="search">
            <el-button
              v-if="search"
              type="primary"
              icon="el-icon-search"
              @click="handleSearch"
              size="small"
              >查询</el-button
            >
            <el-button
              v-if="search"
              type="info"
              icon="el-icon-refresh"
              @click="resetSearch"
              size="small"
              >重置</el-button
            >
          </div>
        </div>

        <div class="log-table-wrapper">
          <el-table
            :data="logList"
            v-loading="tableLoading"
            stripe
            border
            class="business-log-table"
          >
            <el-table-column label="请求时间" width="165" align="center">
              <template slot-scope="scope">
                {{ formatRequestTime(scope.row.requestTime) }}
              </template>
            </el-table-column>
            <el-table-column
              label="实际操作人"
              min-width="180"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-button
                  v-if="canOpenStudentDataLookup(scope.row)"
                  type="text"
                  size="mini"
                  class="student-operator-link"
                  @click="openStudentDataLookup(scope.row.operatorStudentId)"
                >
                  {{ formatOperator(scope.row) }}
                </el-button>
                <span v-else>{{ formatOperator(scope.row) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="业务结果" width="108" align="center">
              <template slot-scope="scope">
                <el-tag
                  size="mini"
                  effect="plain"
                  :type="businessResultTagType(scope.row.businessResult)"
                >
                  {{ formatBusinessResult(scope.row.businessResult) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              label="结果说明"
              min-width="200"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ formatResultSummary(scope.row) }}
              </template>
            </el-table-column>
            <el-table-column
              label="业务操作"
              min-width="180"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{
                  scope.row.executeMsg ||
                  scope.row.executeMethod ||
                  "未标注操作"
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="requestMethod"
              label="方法"
              width="70"
              align="center"
            />
            <el-table-column label="耗时" width="90" align="center">
              <template slot-scope="scope">
                {{ formatDuration(scope.row.executeTime) }}
              </template>
            </el-table-column>
            <el-table-column
              label="详情"
              width="72"
              fixed="right"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="mini"
                  @click="openDetail(scope.row)"
                  >查看</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div style="display: flex; justify-content: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <el-dialog
      title="日志详情"
      :visible.sync="detailVisible"
      width="78%"
      top="6vh"
      @closed="currentLog = null"
    >
      <template v-if="currentLog">
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="请求时间">
            {{ formatRequestTime(currentLog.requestTime) }}
          </el-descriptions-item>
          <el-descriptions-item label="实际操作人">
            {{ formatOperator(currentLog) }}
          </el-descriptions-item>
          <el-descriptions-item label="业务结果">
            {{ formatBusinessResult(currentLog.businessResult) }}
          </el-descriptions-item>
          <el-descriptions-item label="系统状态">
            {{ currentLog.responseState === 1 ? "正常返回" : "系统异常" }}
          </el-descriptions-item>
          <el-descriptions-item label="结果说明" :span="2">
            {{ formatResultSummary(currentLog) }}
          </el-descriptions-item>
          <el-descriptions-item label="业务操作">
            {{
              currentLog.executeMsg || currentLog.executeMethod || "未标注操作"
            }}
          </el-descriptions-item>
          <el-descriptions-item label="耗时">
            {{ formatDuration(currentLog.executeTime) }}
          </el-descriptions-item>
          <el-descriptions-item label="请求地址" :span="2">
            {{ currentLog.requestUrl || "-" }}
          </el-descriptions-item>
          <el-descriptions-item label="来源 IP">
            {{ currentLog.sourceIp || "-" }}
          </el-descriptions-item>
          <el-descriptions-item label="来源浏览器">
            {{ currentLog.sourceBrowser || "-" }}
          </el-descriptions-item>
          <el-descriptions-item label="异常信息" :span="2">
            {{ currentLog.exceptionMsg || "无" }}
          </el-descriptions-item>
        </el-descriptions>

        <div class="raw-log-title">
          <span>原始请求报文</span>
          <el-button
            v-if="designatedSuperAdmin"
            type="primary"
            plain
            size="mini"
            :loading="decryptingType === 'request'"
            @click="decryptLogPayload('request')"
          >
            解密 encrypt
          </el-button>
        </div>
        <pre class="raw-log-content">{{
          formatRawLog(currentLog.requestData)
        }}</pre>
        <div
          v-if="currentLog.decryptedRequestData"
          class="decrypted-log-section"
        >
          <div class="decrypted-log-title">已解密请求内容</div>
          <pre class="decrypted-log-content">{{
            formatRawLog(currentLog.decryptedRequestData)
          }}</pre>
        </div>

        <div class="raw-log-title">
          <span>原始响应报文</span>
          <el-button
            v-if="designatedSuperAdmin"
            type="primary"
            plain
            size="mini"
            :loading="decryptingType === 'response'"
            @click="decryptLogPayload('response')"
          >
            解密响应 data
          </el-button>
        </div>
        <pre class="raw-log-content">{{
          formatRawLog(currentLog.responseData)
        }}</pre>
        <div
          v-if="currentLog.decryptedResponseData"
          class="decrypted-log-section"
        >
          <div class="decrypted-log-title">已解密响应 data</div>
          <pre class="decrypted-log-content">{{
            formatRawLog(currentLog.decryptedResponseData)
          }}</pre>
        </div>
      </template>
    </el-dialog>
  </el-card>
</template>

<script>
import { decryptSystemLogPayload, queryLog } from "@/api/log";
import { dateFormat } from "@/utils/date";
import { queryPageButton } from "@/api/permission";
import { mapGetters } from "vuex";

export default {
  name: "LogQuery",
  computed: {
    ...mapGetters(["designatedSuperAdmin"]),
  },
  data() {
    return {
      searchTimeRange: [],
      searchKeyword: "",
      searchOperatorKeyword: "",
      searchBusinessResult: "",
      searchLogType: "",
      logList: [],
      tableLoading: false,
      detailVisible: false,
      decryptingType: "",
      currentLog: null,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      businessResultOptions: [
        {
          label: "业务成功",
          value: "SUCCESS",
        },
        {
          label: "业务拦截",
          value: "BIZ_REJECTED",
        },
        {
          label: "系统异常",
          value: "SYSTEM_EXCEPTION",
        },
      ],
      logTypeOptions: [
        {
          label: "登录日志",
          value: 1,
        },
        {
          label: "操作日志",
          value: 2,
        },
        // {
        //   label: "工行日志",
        //   value: 3,
        // },
      ],
      search: false,
    };
  },
  created() {
    this.setTimeRange("today");
    this.applyStudentRouteQuery(this.$route.query.studentId);
    this.queryButton();
    this.query();
  },
  watch: {
    // 从学生资料页带学生 ID 返回时，按学生精确定位日志并取消默认的“当天”时间范围。
    "$route.query.studentId"(studentId) {
      if (this.applyStudentRouteQuery(studentId)) {
        this.handleSearch();
      }
    },
  },
  methods: {
    queryButton() {
      const data = 15;
      queryPageButton(data).then((resp) => {
        for (const button of resp.data) {
          if (button.code === "search") {
            this.search = true;
          }
        }
      });
    },
    query() {
      this.tableLoading = true;
      const data = {
        keyword: this.searchKeyword,
        operatorKeyword: this.searchOperatorKeyword,
        businessResult: this.searchBusinessResult,
        logType: this.searchLogType,
        requestTimeStart: this.searchTimeRange[0],
        requestTimeEnd: this.searchTimeRange[1],
      };

      queryLog(this.currentPage, this.pageSize, data)
        .then((resp) => {
          this.logList = resp.data.content || [];
          this.total = resp.data.totalElements || 0;
        })
        .catch(() => {
          this.logList = [];
          this.total = 0;
          this.$message.error("日志查询失败，请稍后重试");
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    handleSearch() {
      this.currentPage = 1;
      this.query();
    },
    resetSearch() {
      this.setTimeRange("today");
      this.searchKeyword = "";
      this.searchOperatorKeyword = "";
      this.searchBusinessResult = "";
      this.searchLogType = "";
      this.currentPage = 1;
      this.query();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      // 每页条数变化后回到第一页，避免沿用末页页码而查到空列表。
      this.currentPage = 1;
      this.query();
    },
    handleCurrentChange(val) {
      // 切换每页条数时，分页组件可能再次通知第一页，避免重复发起同一查询。
      if (this.currentPage === val) {
        return;
      }
      this.currentPage = val;
      this.query();
    },
    applyStudentRouteQuery(studentId) {
      if (!studentId) {
        return false;
      }
      this.searchOperatorKeyword = String(studentId);
      // 学生资料页跳转过来的场景需要核对该学生的完整操作历史，不能只保留当天日志。
      this.searchTimeRange = [];
      return true;
    },
    // 只有已写入学生 ID 且具备资料综合查询权限的记录，才提供跳转入口。
    canOpenStudentDataLookup(log) {
      return Boolean(this.designatedSuperAdmin && log.operatorStudentId);
    },
    openStudentDataLookup(studentId) {
      this.$router.push({
        name: "StudentDataLookup",
        query: { studentId: String(studentId) },
      });
    },
    setTimeRange(rangeType) {
      const now = new Date();
      const start = new Date(now);
      const end = new Date(now);
      if (rangeType === "yesterday") {
        start.setDate(start.getDate() - 1);
        start.setHours(0, 0, 0, 0);
        end.setDate(end.getDate() - 1);
        end.setHours(23, 59, 59, 999);
      } else if (rangeType === "sevenDays") {
        start.setDate(start.getDate() - 6);
        start.setHours(0, 0, 0, 0);
      } else {
        start.setHours(0, 0, 0, 0);
      }
      this.searchTimeRange = [
        dateFormat("YYYY-mm-dd HH:MM:SS", start),
        dateFormat("YYYY-mm-dd HH:MM:SS", end),
      ];
    },
    formatRequestTime(value) {
      if (!value) {
        return "-";
      }
      return dateFormat("YYYY-mm-dd HH:MM:SS", new Date(value));
    },
    formatDuration(value) {
      if (value === null || value === undefined || value === "") {
        return "-";
      }
      return value + " ms";
    },
    formatOperator(log) {
      if (log.operatorStudentName) {
        return log.operatorStudentId
          ? log.operatorStudentName + "（" + log.operatorStudentId + "）"
          : log.operatorStudentName;
      }
      if (log.operatorStudentId) {
        return log.operatorStudentId;
      }
      if (log.userName) {
        return log.userName;
      }
      return "未识别";
    },
    formatBusinessResult(value) {
      const labels = {
        SUCCESS: "业务成功",
        BIZ_REJECTED: "业务拦截",
        SYSTEM_EXCEPTION: "系统异常",
      };
      return labels[value] || "未识别";
    },
    businessResultTagType(value) {
      const types = {
        SUCCESS: "success",
        BIZ_REJECTED: "warning",
        SYSTEM_EXCEPTION: "danger",
      };
      return types[value] || "info";
    },
    // 列表摘要只展示 ResultVo.message 或异常信息，并对常见身份证、手机号做脱敏处理。
    formatResultSummary(log) {
      let summary = "";
      try {
        const response = JSON.parse(log.responseData);
        summary = response.message || "";
      } catch (error) {
        summary = "";
      }
      if (!summary && log.exceptionMsg) {
        summary = log.exceptionMsg;
      }
      return summary ? this.maskSensitiveSummary(summary) : "-";
    },
    maskSensitiveSummary(value) {
      return String(value)
        .replace(/(1[3-9]\d)\d{4}(\d{4})/g, "$1****$2")
        .replace(/(\d{6})\d{8}(\d{3}[0-9Xx])/g, "$1********$2");
    },
    openDetail(log) {
      this.currentLog = {
        ...log,
        decryptedRequestData: "",
        decryptedResponseData: "",
      };
      this.detailVisible = true;
    },
    /**
     * 解密按钮只提交日志主键与报文方向；具体密文由服务端从该日志中提取。
     */
    decryptLogPayload(payloadType) {
      if (!this.currentLog || !this.currentLog.id) {
        return;
      }
      this.decryptingType = payloadType;
      decryptSystemLogPayload({
        logId: this.currentLog.id,
        payloadType,
      })
        .then((response) => {
          const decryptedData = response.data && response.data.decryptedData;
          if (payloadType === "request") {
            this.$set(
              this.currentLog,
              "decryptedRequestData",
              decryptedData || ""
            );
          } else {
            this.$set(
              this.currentLog,
              "decryptedResponseData",
              decryptedData || ""
            );
          }
        })
        .finally(() => {
          this.decryptingType = "";
        });
    },
    // 保留 sys_log 原始报文的字段顺序；JSON 格式化仅用于提高详情可读性。
    formatRawLog(value) {
      if (value === null || value === undefined || value === "") {
        return "无";
      }
      try {
        return JSON.stringify(JSON.parse(value), null, 2);
      } catch (error) {
        return String(value);
      }
    },
  },
};
</script>

<style scoped>
.card {
  min-height: calc(100% - 4px);
}

.cardBody {
  min-height: calc(100% - 40px);
}

.log-page-content {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 180px);
}

.condition-item {
  display: flex;
  align-items: center;
  margin: 0 16px 12px 0;
}

.condition-item .fn-14 {
  flex: 0 0 auto;
  margin-right: 8px;
}

.time-range {
  width: 360px;
  margin-right: 8px;
}

.quick-time-range {
  flex: 0 0 auto;
}

.log-table-wrapper {
  margin-bottom: 15px;
  overflow-x: auto;
}

.business-log-table {
  width: 100%;
}

.raw-log-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 14px 0 6px;
  color: #303133;
  font-weight: 600;
}

.student-operator-link {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}

.raw-log-content {
  max-height: 260px;
  margin: 0;
  padding: 12px;
  overflow: auto;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #f8fafc;
  color: #303133;
  font-family: Consolas, Monaco, monospace;
  font-size: 12px;
  line-height: 1.55;
  white-space: pre-wrap;
  word-break: break-all;
}

.decrypted-log-section {
  margin-top: 8px;
}

.decrypted-log-title {
  color: #67c23a;
  font-size: 13px;
  font-weight: 600;
}

.decrypted-log-content {
  max-height: 260px;
  margin: 6px 0 0;
  padding: 12px;
  overflow: auto;
  border: 1px solid #d9ecff;
  border-radius: 4px;
  background: #f0f9eb;
  color: #303133;
  font-family: Consolas, Monaco, monospace;
  font-size: 12px;
  line-height: 1.55;
  white-space: pre-wrap;
  word-break: break-all;
}

@media screen and (max-width: 768px) {
  .condition-item {
    align-items: flex-start;
    flex-wrap: wrap;
  }

  .time-range {
    width: 280px;
    margin-bottom: 8px;
  }
}
</style>
